import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const addDiagnosticLessonGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const clientId = route.queryParamMap.get('clientId');
  const dealId = route.queryParamMap.get('dealId');

  if (!clientId || !dealId) {
    return router.createUrlTree(['/']);
  }

  return true;
};
